import React, { useEffect, useState } from 'react'
import { components } from 'react-select'
import { AsyncPaginate, wrapMenuList } from 'react-select-async-paginate'
import Checkbox from '../Checkbox/Checkbox'
import ContentEditor from './ContentEditor'
import FieldLabel from '../FieldLabel/FieldLabel'
import SkeletonTile from '../SkeletonTile/SkeletonTile'
import Icon from '../Icon2/Icon'
import { Truncate } from '../Truncate/Truncate'

const SingleValue = (props) => {
  const options = props.getValue()
  const { updateOption, ...rest } = props
  return (
    <components.SingleValue {...rest}>
      {options.map((option: any, index: number) => {
        return <ContentEditor key={index} value={option.label} option={option} updateOption={updateOption} />
      })}
    </components.SingleValue>
  )
}

const MultiValueLabel = (props: any) => {
  const { updateOption, ...rest } = props
  return (
    <components.MultiValueLabel {...rest}>
      <ContentEditor value={rest.data.label} option={rest.data} updateOption={updateOption} />
    </components.MultiValueLabel>
  )
}

export const SkeletonLoader = ({ size = 2, isMulti = false }) => {
  return (
    <div>
      {Array(size)
        .fill(1)
        .map((data, index) => {
          return (
            <div className="flex-v-center" key={index}>
              {isMulti && (
                <SkeletonTile
                  numberOfTiles={1}
                  tileHeight={16}
                  tileWidth={16}
                  tileRadius={4}
                  tileBottomSpace={10}
                  tileTopSpace={10}
                  tileleftSpace={20}
                />
              )}
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={12}
                tileWidth={isMulti ? 105 : 145}
                tileRadius={6}
                tileBottomSpace={12}
                tileTopSpace={12}
                tileleftSpace={isMulti ? 12 : 20}
              />
            </div>
          )
        })}
    </div>
  )
}

// const getValueContainer = ({
//   showAllSelectedItems: showAll,
//   setShowAllSelectedItems: setShowAll,
//   multiDisplayLimit,
//   isValueContainer,
//   version
// }: {
//   showAllSelectedItems: boolean
//   setShowAllSelectedItems: React.Dispatch<React.SetStateAction<boolean>>
//   multiDisplayLimit: number
//   isValueContainer: boolean
//   version: string
// }) => {
//   return ({ children, hasValue, ...props }) => {
//     if (!hasValue) {
//       return <components.ValueContainer {...props}>{children}</components.ValueContainer>
//     }

//     const [selectedItems, otherChildren] = children
//     // const itemsToDisplay = showAll ? selectedItems : selectedItems.slice(0, multiDisplayLimit)
//     let newSelectedItemsWithtitle = selectedItems
//     if (version === 'v2') {
//       newSelectedItemsWithtitle = selectedItems.map((iSelected, index) => {
//         return <div data-test-id={`cs-selectected-pills-${index}`} key={index} title={iSelected?.props?.data?.label}>{iSelected}</div>
//       })
//     }
//     const itemsToDisplay = showAll ? newSelectedItemsWithtitle : newSelectedItemsWithtitle.slice(0, multiDisplayLimit)
//     const overflowCounter = selectedItems.length - multiDisplayLimit

//     return (
//       <components.ValueContainer {...props}>
//         <div className="Select__value-container--custom">
//           {itemsToDisplay}
//           {!showAll && overflowCounter > 0 && (
//             <button
//               className="Select__see-more-button"
//               id="see-more-button"
//               onClick={() => {
//                 setShowAll(true)
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault()
//                 e.stopPropagation()
//               }}>
//               {`+${overflowCounter} More`}
//             </button>
//           )}
//           {showAll && overflowCounter > 0 && (
//             <button
//               className="Select__see-less-button"
//               id="see-less-button"
//               onClick={() => {
//                 setShowAll(false)
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault()
//                 e.stopPropagation()
//               }}>
//               {`See Less`}
//             </button>
//           )}
//           {otherChildren}
//         </div>
//       </components.ValueContainer>
//     )
//   }
// }


const getValueContainer = ({ children, hasValue, ...props }) => {
  const { multiDisplayLimit, version, showAllSelectedItems: showAll, setShowAllSelectedItems: setShowAll, displayAllSelectedOptions } = props.selectProps

  const [selectedItems, otherChildren] = children;

  let newSelectedItemsWithTitle;
  let itemsToDisplay = selectedItems;
  let overflowCounter;

  // if (!hasValue ) {
  //   return <components.ValueContainer {...props}>{children}</components.ValueContainer>
  // }

  if (Array.isArray(selectedItems)) {

    newSelectedItemsWithTitle = selectedItems
    if (version === 'v2') {
      newSelectedItemsWithTitle = selectedItems.map((iSelected, index) => {
        const pillLabel = iSelected?.props?.data?.label
        return <div data-test-id={`cs-selectected-pills-${index}`} key={index} title={typeof pillLabel === 'string' ? pillLabel : undefined}>{iSelected}</div>
      })
    }
    itemsToDisplay = showAll || displayAllSelectedOptions ? newSelectedItemsWithTitle : newSelectedItemsWithTitle.slice(0, multiDisplayLimit)
    overflowCounter = selectedItems.length - multiDisplayLimit
  }


  return (
    <components.ValueContainer {...props}>
      <div className="Select__value-container--custom">
        {itemsToDisplay}
        {hasValue && !showAll && overflowCounter > 0 && !displayAllSelectedOptions && (
          <button
            className="Select__see-more-button"
            id="see-more-button"
            onClick={() => {
              setShowAll(true)
            }}
            onMouseDown={(e) => {
              e.preventDefault()
              e.stopPropagation()
            }}>
            {`+${overflowCounter} More`}
          </button>
        )}
        {hasValue && showAll && overflowCounter > 0 && !displayAllSelectedOptions && (
          <button
            className="Select__see-less-button"
            id="see-less-button"
            onClick={() => {
              setShowAll(false)
            }}
            onMouseDown={(e) => {
              e.preventDefault()
              e.stopPropagation()
            }}>
            {`See Less`}
          </button>
        )}
        {otherChildren}
      </div>
    </components.ValueContainer>
  )
}
const MenuList = wrapMenuList((props: any) => {
  return (
    <components.MenuList {...props}>
      {props.children}
      {props.isLoading && <SkeletonLoader size={2} isMulti={props.isMulti} />}
    </components.MenuList>
  )
})

const Option = (props: any) => {
  if (props.isMulti) {
    return (
      <components.Option {...props}>
        <Checkbox
          checked={props.isSelected}
          label={props.children}
          fullWidth={true}
          isLabelFullWidth={true}
          testId={props.data.testId || 'cs-async-select-element'}
          tooltipContent={typeof props.data.label === 'string' ? props.data.label : undefined}
        />
      </components.Option>
    )
  }
  if (props.containsLink) {
    return <components.Option {...props} title={props.label}>
      <a href={props.data.redirectURL && props.data.redirectURL} onClick={(e) => e.preventDefault()} id='async-select-element-link'>
        <div data-test-id={props.data.testId || 'cs-async-select-element'}>
          {props.children}
        </div>
      </a>
    </components.Option>
  }

  return <components.Option {...props} title={props.label}>
    <div data-test-id={props.data.testId || 'cs-async-select-element'}>
      {props.children}
    </div>
  </components.Option>
}

const customComponents = ({
  updateOption,
  canEditOption,
  isMulti,
  multiDisplayLimit,
  version,
  displayAllSelectedOptions,
  containsLink,
}: any) => {
  let selectObj = {};
  if (version === 'v2') {
    selectObj = {
      ...selectObj, DropdownIndicator: (props) => {
        return (
          <components.DropdownIndicator {...props}>
            <Icon
              icon="CaretDownNew"
              version='v2'
              size="medium"
              className='select-caret-down'
              testId='cs-async-select-caret-down'
            />
          </components.DropdownIndicator>
        )
      },
      ClearIndicator: (props) => {
        return (
          <components.ClearIndicator {...props}>
            <Icon
              icon="Cancel"
              version='v2'
              size="medium"
              className='select-clear-all'
              testId='cs-async-select-clear-all'
            />
          </components.ClearIndicator>
        )
      },
      MultiValueRemove: (props) => {
        return (
          <components.MultiValueRemove {...props}>
            <Icon
              icon="Cancel"
              version='v2'
              className='mr-8 flex-v-center'
              height={16}
              width={16}
              testId='cs-async-select-remove'
            />
          </components.MultiValueRemove>
        )
      }
    }
  }
  if (canEditOption) {
    return selectObj = {
      ...selectObj,
      SingleValue: (props: any) => <SingleValue {...props} updateOption={updateOption} />,
      MultiValueLabel: (props: any) => <MultiValueLabel {...props} updateOption={updateOption} />,
      Option,
      MenuList
    }
  }
  if (isMulti && (multiDisplayLimit || displayAllSelectedOptions)) {
    return selectObj = {
      ...selectObj,
      Option,
      ValueContainer: getValueContainer,
      MenuList
    }
  }
  if (containsLink) {
    return selectObj = {
      ...selectObj,
      Option: (props: any) => <Option {...props} containsLink={true} />,
      MenuList
    }
  }
  return selectObj = {
    ...selectObj,
    Option,
    MenuList
  }
}

export type LoadMoreArgsProps = {
  search?: string
  skip: number
  limit: number
  prevOptions?: any
}

type InitArrayProps = {
  label: String
  value: String
}

export type LoadMoreOptReturnProps = {
  options: any
  hasMore: boolean
}

export type SelectProps = {
  width?: string
  maxWidth?: string
  minWidth?: string
  name?: string
  isDisabled?: boolean
  isClearable?: boolean
  isMulti?: boolean
  isSearchable?: boolean
  placeholder?: string
  hideSelectedOptions?: boolean
  menuShouldScrollIntoView?: boolean
  menuPlacement?: 'auto' | 'bottom' | 'top'
  menuIsOpen?: boolean
  maxMenuHeight?: number
  minMenuHeight?: number
  onChange: Function
  onBlur?: Function
  onMenuOpen?: () => void
  onMenuClose?: () => void
  value: any
  canEditOption?: boolean
  selectLabel?: string
  updateOption?: (UpdateOptionProps: { label: any; id: any }) => void
  limit?: number
  loadMoreOptions: (loadmoreArgs: LoadMoreArgsProps) => Promise<LoadMoreOptReturnProps>
  // totalCounts: number
  initialOptions?: Array<InitArrayProps>
  defaultOptions?: boolean
  error?: boolean
  debounceTimeout?: number
  multiDisplayLimit?: number
  version?: string
  testId?: string
  styles?: any,
  menuPortalTarget?: object,
  openOnHover?: boolean,
  hasIcon?: boolean,
  shouldRefetch?: boolean,
  displayAllSelectedOptions?: boolean,
  truncateLabel?: boolean
  noOptionsMessage?: any
  containsLink?: boolean
  tabSelectsValue?: boolean
  classNamePrefix?: string
}

const AsyncSelectBox: React.FunctionComponent<SelectProps> = (props) => {
  const labelTruncateFlag = props?.truncateLabel === true
  let limit = props.limit || 10
  let controlledMultidisplayLimit = props.multiDisplayLimit || 2
  const [showAllSelectedItems, setShowAllSelectedItems] = useState(false)
  const [menuIsOpen, setMenuIsOpen] = useState(props.menuIsOpen ?? false);
  const [cacheUniqs, setCacheUniqs] = useState(0);
  const [loadedOptions, setLoadedOptions] = useState({
    options: [],
    hasMore: false
  })


  useEffect(() => {
    if (!props.openOnHover) {
      setMenuIsOpen(props.menuIsOpen || false);
    }
  }, [props.menuIsOpen, props.openOnHover])

  const loadOptions = async (search: any, prevOptions: any) => {
    try {
      if (search && loadedOptions?.options?.length > 0 && props.shouldRefetch) {
        const filteredOptions = loadedOptions.options.filter((option: any) =>
          option?.label?.toLowerCase()?.includes(search.toLowerCase())
        )
        return {
          options: filteredOptions,
          hasMore: loadedOptions.hasMore
        }
      }

      let skip = prevOptions.length
      const response: any = await props.loadMoreOptions({ search: search || '', skip, limit, prevOptions })

      const finalResponse = {
        options: response.options,
        hasMore: response.hasMore
      }

      setLoadedOptions(finalResponse)
      return finalResponse
    } catch (error) {
      console.log('loadOptions error', error)
    }
  }

  const handleMenuOpen = () => {
    setMenuIsOpen(true)
    if (props.shouldRefetch) {
      setCacheUniqs(prev => prev + 1)
    }
    if (props.onMenuOpen) {
      props.onMenuOpen()
    }
  }

  const allComponents = customComponents({
    updateOption: props.updateOption,
    canEditOption: props.canEditOption,
    isMulti: props.isMulti,
    multiDisplayLimit: controlledMultidisplayLimit,
    showAllSelectedItems: showAllSelectedItems,
    setShowAllSelectedItems: setShowAllSelectedItems,
    version: props.version,
    displayAllSelectedOptions: props.displayAllSelectedOptions,
    containsLink: props.containsLink,
  })

  let widthStyleObj: any = {}
  if (props.width) {
    widthStyleObj = { width: props.width }
  } else {
    widthStyleObj = { maxWidth: props.maxWidth || '500px', minWidth: props.minWidth || '200px' }
  }

  return (
    <div
      data-test-id={props.testId ? props.testId : "cs-select-async"}
      className={`Aync--Select Select ${props.error ? 'Select--error' : ''} ${props.version === 'v2' ? 'Select__v2' : ''} ${props.canEditOption ? 'Select--can-edit' : ''}`}
      style={{ ...widthStyleObj }}
      onMouseEnter={props.openOnHover ? () => setMenuIsOpen(true) : undefined}
      onMouseLeave={props.openOnHover ? () => setMenuIsOpen(false) : undefined}
    >
      {props.selectLabel && <FieldLabel htmlFor="selectLabel">{props.selectLabel}</FieldLabel>}
      <AsyncPaginate
        name={props.name}
        closeMenuOnSelect={!props.isMulti}
        isDisabled={props.isDisabled || false}
        isClearable={props.isClearable || false}
        isMulti={props.isMulti || false}
        multiDisplayLimit={props.multiDisplayLimit || controlledMultidisplayLimit}
        displayAllSelectedOptions={props.displayAllSelectedOptions}
        isSearchable={props.isSearchable || false}
        placeholder={props.placeholder || 'Select ...'}
        hideSelectedOptions={props.hideSelectedOptions || false}
        closeMenuOnScroll={true}
        menuShouldBlockScroll={false}
        menuShouldScrollIntoView={props.menuShouldScrollIntoView}
        menuPlacement={props.menuPlacement}
        menuIsOpen={menuIsOpen}
        onMenuOpen={handleMenuOpen}
        onMenuClose={() => {
          setMenuIsOpen(false)
          if (props.onMenuClose) {
            props.onMenuClose()
          }
        }}
        maxMenuHeight={props.maxMenuHeight || 200}
        minMenuHeight={props.minMenuHeight}
        onChange={props.onChange}
        // onInputChange={handleInputChange}
        onBlur={props.onBlur}
        value={props.value}
        components={allComponents}
        backspaceRemovesValue={props.canEditOption ? false : true}
        loadOptions={loadOptions}
        defaultOptions={typeof props.defaultOptions === 'boolean' ? props.defaultOptions : true}
        classNamePrefix={
          props.classNamePrefix 
            ? `${props.classNamePrefix} ${props.menuPortalTarget ? 'Portal' : 'Select'}`
            : (props.menuPortalTarget ? 'Portal' : 'Select')
        }
        loadingMessage={() => ''}
        options={props.initialOptions}
        aria-label={'cs-async-select-aria'}
        debounceTimeout={props.debounceTimeout}
        isValueContainer={props.multiDisplayLimit ? true : false}
        version={props.version}
        showAllSelectedItems={showAllSelectedItems}
        setShowAllSelectedItems={setShowAllSelectedItems}
        styles={props.styles}
        menuPortalTarget={props.menuPortalTarget}
        tabSelectsValue={props.tabSelectsValue}
        getOptionLabel={(e) => {
          if (props.hasIcon && e.icon) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', width: '100%'}}>
                <img
                  src={e.icon}
                  alt=""
                  style={{ width: 24, height: 24, marginRight: 4 }}
                />
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', flex: 1}}>
                  {labelTruncateFlag ? (
                    <Truncate isResponsive={true}>
                      {e.label}
                    </Truncate>
                  ) : (
                    e.label
                  )}
                </span>
              </div>
            );
          } else {
            return (
              <div>
                {labelTruncateFlag ? (
                  <Truncate isResponsive={true}>
                    {e.label}
                  </Truncate>
                ) : (
                  e.label
                )}
              </div>
            )
          }
        }}
        cacheUniqs={[cacheUniqs]}
        noOptionsMessage={props.noOptionsMessage}
      />
    </div>
  )
}

export default React.memo(AsyncSelectBox)
